// Analytics — thin wrapper over window.gtag (GA4). No-op when gtag is absent,
// so we can sprinkle .track() calls without worrying about dev environments.

import { DEBUG } from "./query"

type EventParams = Record<string, string | number | boolean | null | undefined>

declare global {
  interface Window {
    gtag?: (command: "event" | "config" | "set" | "consent", eventName: string, params?: EventParams) => void
    dataLayer?: unknown[]
  }
}

export const Analytics = {
  track(eventName: string, params: EventParams = {}): void {
    // ?debug=true logs every event, including the ones that were sent — the
    // point is to see what's firing on a page where gtag is present, which a
    // no-gtag fallback log can't show you. Logged before the send so an event
    // that throws in gtag still leaves a trace.
    if (DEBUG) {
      console.debug("[analytics]", eventName, params, window.gtag ? "(sent)" : "(no gtag)")
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params)
      return
    }

    // Helpful in development: log the event so we can see what would have been
    // sent. Drops silently in production builds because nobody's looking.
    // Skipped when DEBUG already logged it above.
    if (!DEBUG && typeof console !== "undefined" && console.debug) {
      console.debug("[analytics]", eventName, params)
    }
  },
}
